import { Select, Form, Col, Input, Modal, message } from "antd";
import React, { useState } from "react";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import SessionError from "../../ApiErrorComp/SessionError";
import liracrypt from "../../Liracrypt/liracrypt";
import { debounce } from 'lodash';
import dayjs from "dayjs";

function UniDropAdv({
  allowClear,
  controlHeight,
  LocalDict = [],
  minSearchLength = 3,
  labelCol,
  isCache,
  cacheId,
  form,
  colSpan,
  source,
  url,
  labelSpan,
  urlData,
  extraData,
  options,
  data,
  defaultValue,
  name,
  pname,
  label,
  required,
  errorMessage,
  placeholder,
  multiSelect,
  disabled,
  includeAll,
  searchable,
  onChange,
  labelAsVal,
  bg = '#ffffff',
  onChangeConfMsg
}) {
  const [loading, setLoading] = React.useState(false);
  const [dropOptions, setDropOptions] = React.useState([]);
  const [inverseDropOptions, setInverseDropOptions] = React.useState([]);
  const [dropSearch, setDropSearch] = React.useState({});
  const [loginError, setLoginError] = React.useState(false);
  const [config, setConfig] = useState();
  const dtArray = ["datePicker", "rangePicker", "dateTimePicker", "timePicker"];

  // console.log(options);

  const fetchApiData = () => {
    // console.log("UNI Fetch");
    if (url) {
      let data = { ...extraData, ...urlData };
      Object.keys(data).forEach((key) => {
        if (data[key]) {
          if (Array.isArray(data[key]) && LocalDict[key]) {
            data[
              LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
            ] = dayjs(data[key][0]).format(LocalDict[key]).toString();
            data[LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"] =
              dayjs(data[key][1]).format(LocalDict[key]).toString();
            delete data[key];
          } else {
            if (LocalDict[key]) {
              data[key] = dayjs(data[key]).format(LocalDict[key]).toString();
            }
          }
        }
      });
      liracrypt
        .get(url, { ...data })
        .then((res, req) => {
          setConfig(res.data?.config)
          if (cacheId) {
            setCacheData(
              cacheId,
              res.data.data.data ? res.data.data.data : res.data.data
            );
          } else {
            if (source === "mdict") {
              setCacheData(
                urlData["typ"] + "_" + urlData["subTyp"],
                res.data.data.data ? res.data.data.data : res.data.data
              );
            } else {
              setCacheData(
                urlData["name"],
                res.data.data.data ? res.data.data.data : res.data.data
              );
            }
          }

          parseData(res.data.data.data ? res.data.data.data : res.data.data);
        })
        .catch((err) => {
          console.log(err, 'error')
          parseData(null);
          if (err.response !== undefined) {
            if (err.response.status !== 401) {
              // ApiErrorComp(err.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    };
  };


  const fetchLocalData = (id) => {
    let IterOptions = {};
    if (options) {
      IterOptions = options;
    } else {
      let localData;
      if (id) {
        localData = getCacheData(id);
      } else {
        if (source === "mdict") {
          localData = getCacheData(urlData["typ"] + "_" + urlData["subTyp"]);
        } else {
          localData = getCacheData(urlData["name"]);
        }
      }

      // console.log(localData);
      if (localData) {
        IterOptions = localData;
      }
    }
    return IterOptions;
  };

  const parseData = (IterOptions) => {
    let optionList = [];
    let inverseList = {};
    let drop = {};
    if (!IterOptions) {
      setDropOptions(null);
      setInverseDropOptions(null);
      setDropSearch(null);
      return;
    }
    if (includeAll) {
      optionList.push({ label: "All", value: "all" });
      inverseList["all"] = "All";
      drop["All"] = "all";
    }
    Object.keys(IterOptions).forEach((value, index) => {
      // optionList.push({ label: IterOptions[value], value: value });
      optionList.push({ label: IterOptions[value], value: IterOptions[value] });
      inverseList[value] = IterOptions[value];

      drop[IterOptions[value]] = value;
    });

    if (defaultValue) {
      let defaultPNameValue = [];
      if (multiSelect) {
        defaultValue.forEach(x => {
          defaultPNameValue.push(inverseList[x]);
        })
      }
      form.setFieldsValue({ [`${pname}`]: multiSelect ? defaultPNameValue : inverseList[defaultValue] });
    }
    setDropOptions(optionList);
    setInverseDropOptions(inverseList);
    setDropSearch(drop);
    setLoading(false);
  };

  function setCacheData(key, value) {
    let __key = `cache_dropdown_${key}`;
    const now = new Date();
    const item = {
      value: { data: value },
      expiry: now.getTime() + 600000,
    };
    localStorage.setItem(__key, JSON.stringify(item));
  }

  function getCacheData(key) {
    let __key = `cache_dropdown_${key}`;
    const itemStr = localStorage.getItem(__key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    return item.value.data ? item.value.data : item.value;
  }

  React.useEffect(() => {
    if (defaultValue) {
      form.setFieldsValue({ [name]: defaultValue });
      form.setFieldsValue({ [pname]: ' ' });
    }
  }, [defaultValue]);

  React.useEffect(() => {
    setLoading(true);
    // console.log(name, pname);
    let IterOptions;
    let dynamicSource = ['dynamic', 'dynamicSearch']
    if (!dynamicSource.includes(source)) {
      IterOptions = fetchLocalData();
    };

    if (isCache && cacheId) {
      IterOptions = fetchLocalData(cacheId);
    };

    if (IterOptions && Object.keys(IterOptions).length > 0) {
      parseData(IterOptions);
    } else {
      if (source !== 'dynamicSearch') {
        fetchApiData();
      } else {
        setLoading(false);
      }
    }
  }, [cacheId, label]);

  const getNameFromId = (id) => {
    return inverseDropOptions[id];
  };

  const getIdFromName = (name) => {
    if (name === 'all') {
      return 'all'
    }
    return name ? dropSearch[name] : null;
  };


  const onSelectChange = (value) => {
    if (multiSelect) {
      let idArray = [];

      value.forEach((element, index) => {
        idArray.push(getIdFromName(element));
      });
      form.setFieldsValue({ [`${name}`]: idArray });
    } else {
      if (value === "all") {
        form.setFieldsValue({
          [`${name}`]: value,
        });
        form.setFieldsValue({
          [`${pname}`]: "All",
        });
      } else {
        form.setFieldsValue({
          [`${name}`]: labelAsVal ? value : getIdFromName(value),
        });
        // form.setFieldsValue({ [`${pname}`]: value });
      }
    }
  }


  const onChangeConfirmation = (value) => {
    if (!onChangeConfMsg) return;
    if (value === defaultValue) return;
    Modal.confirm({
      title: onChangeConfMsg.text,
      okText: onChangeConfMsg.okButtonLabel,
      cancelText: onChangeConfMsg.cancelButtonLabel,
      cancelButtonProps: { danger: true, type: 'primary' },
      // okButtonProps: {  },
      onOk: () => { onSelectChange(value) },
      onCancel: () => {
        form.setFieldsValue({ [name]: defaultValue });
        form.setFieldsValue({ [`${pname}`]: getIdFromName(defaultValue) });
        // console.log(dropOptions, value, getIdFromName(value));
      }
    });
  }

  const onSearch = debounce((val) => {
    if (val.length < minSearchLength) {
      setDropOptions(null);
      setInverseDropOptions(null);
      setDropSearch(null);
      return;
    };
    setLoading(true);
    liracrypt.get(url, { ...extraData, ...urlData, search: val })
      .then(response => {
        setLoading(false);
        parseData(response.data.data.data ? response.data.data.data : response.data.data);

      }).catch(err => {
        setLoading(false);
        message.error('Something went wrong');
        console.log(err);
      })
  }, 500);


  return (
    <>
      <SessionError visible={loginError} />
      {/* <Form.Item name={pname} style={{ display: "none" }}></Form.Item>
        <Form.Item
          initialValue={defaultValue ? defaultValue : null}
          name={name}
          label={label}
          style={{ marginRight: "10px", fontWeight: 600 }}
          rules={[
            {
              required: required,
              message: errorMessage,
            },
          ]}
        >
          <Select
            loading={loading}
            showSearch={searchable ? searchable : false}
            onChange={(value) => {
              console.log(value);
              if (multiSelect) {
                let nameArray = [];
                value.forEach((element, index) => {
                  nameArray.push(getNameFromId(element));
                });
                console.log(nameArray);
                form.setFieldsValue({ [`${pname}`]: nameArray });
              } else {
                form.setFieldsValue({
                  [`${pname}`]: getNameFromId(value),
                });
              }
              if (onChange) {
                onChange(value);
              }
            }}
            defaultValue={defaultValue}
            placeholder={placeholder}
            defaultActiveFirstOption={true}
            disabled={disabled}
            mode={multiSelect ? "multiple" : ""}
            options={dropOptions}
          />
        </Form.Item> */}
      <Form.Item
        // initialValue={defaultValue}
        name={name}
        hidden
      >
        <Input />
      </Form.Item>
      <Form.Item
        wrapperCol={!label ? { span: 24 } : undefined}
        // initialValue={defaultValue ? defaultValue : null}
        labelCol={{ span: labelCol || labelSpan || 8 }}
        name={pname}
        label={label}
        style={{ marginRight: "10px", fontWeight: 600, background: bg }}
        rules={[
          {
            required: required,
            message: errorMessage,
          },
        ]}
      >
        <Select
          filterOption={source !== 'dynamicSearch'}
          allowClear={allowClear}
          onSearch={source === 'dynamicSearch' ? onSearch : undefined}
          style={{ background: bg, minHeight: controlHeight || 40 }}
          loading={loading}
          showSearch={searchable ? searchable : false}
          onChange={(value) => {
            if (onChangeConfMsg) {
              onChangeConfirmation(value);
            } else {
              onSelectChange(value);
            }
            if (onChange) {
              onChange(value, getIdFromName(value), { params: config?.params ? { ...config.params } : undefined });
            }
          }}
          //  defaultValue={defaultValue}
          placeholder={placeholder}
          defaultActiveFirstOption={true}
          disabled={disabled}
          mode={multiSelect ? "multiple" : ""}
          options={dropOptions}
        />
      </Form.Item>
    </>
  );
}

export default UniDropAdv;
